function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.336-1.875a.352.352,0,0,0,.352-.352V-3.4a.352.352,0,0,0-.352-.352H3.164a.352.352,0,0,0-.352.352v1.172a.352.352,0,0,0,.352.352Zm-3.4-.352V-3.4A.352.352,0,0,0,.586-3.75H-.586A.352.352,0,0,0-.938-3.4v1.172a.352.352,0,0,0,.352.352H.586A.352.352,0,0,0,.937-2.227Zm-3.75,0V-3.4a.352.352,0,0,0-.352-.352H-4.336a.352.352,0,0,0-.352.352v1.172a.352.352,0,0,0,.352.352h1.172A.352.352,0,0,0-2.813-2.227ZM7.5-7.734a.7.7,0,0,0-1.018-.629L1.875-6.06V-7.734A.7.7,0,0,0,.857-8.363L-3.75-6.06v-5.425a.7.7,0,0,0-.7-.7H-6.8a.7.7,0,0,0-.7.7V.234a.7.7,0,0,0,.7.7H6.8a.7.7,0,0,0,.7-.7ZM-4.688-4.922a.234.234,0,0,0,.339.21L.937-7.355v2.433a.234.234,0,0,0,.339.21L6.562-7.355V0H-6.563V-11.25h1.875Z",
  transform: "translate(7.5 12.187)",
  opacity: 0.871
});

var SvgIconSide03 = function SvgIconSide03(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13.125,
    viewBox: "0 0 15 13.125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSide03, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-side-03.9219a4b9.svg";
export { ForwardRef as ReactComponent };